// extracted by mini-css-extract-plugin
export default {"centered":"UserWorklistsPage-styles-module--centered--Xd7EU"};